import { connect } from "react-redux";
import KnowledgeCenter from "./knowledgeCenter";
import { bindActionCreators } from "redux";
import { getDocsList } from "services/redux/brandActivtion/products/action"

const mapStateToProps = (state) => {
  return ({
    viewDocsList: state.productsReducer.viewDocsList
});}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getDocsList }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(KnowledgeCenter);
